import * as React from 'react'

import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

interface Props {
  disabled?: boolean
  field: Field | undefined
  multi?: boolean
  useEmployee?: boolean
}

export const UserSelect = observer(
  ({ field, disabled = false, multi = false, useEmployee }: Props) => {
    if (multi) {
      const value = (field?.value ?? []) as number[]
      return (
        <EmployeeSelectorV2
          multiple
          useAccessId={!useEmployee}
          value={value}
          disabled={disabled}
          onChange={(state: EmployeeSelectorV2MultiSelectState) => {
            if (state.type === 'manual') {
              field?.set(state.ids)
            }
          }}
          options={{ disableSelectAll: true }}
        />
      )
    }
    const value = field?.value as number | undefined
    return (
      <EmployeeSelectorV2
        useAccessId={!useEmployee}
        value={value}
        disabled={disabled}
        onChange={(id: number | undefined) => field?.set(id)}
        options={{ disableSelectAll: true }}
      />
    )
  }
)
